import React, { createContext, FC, ReactNode, useCallback, useContext, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

export const ShowAllContext = createContext<{ ref?: React.RefObject<HTMLButtonElement> }>({});

export const ShowAllContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const ref = useRef<HTMLButtonElement>(null);

    return (
        <ShowAllContext.Provider value={{ ref }}>
            <ShowAllQueryParam />
            {children}
        </ShowAllContext.Provider>
    );
};

const ShowAllQueryParam = () => {
    const [, setSearchParams] = useSearchParams();

    const onShowAll = useCallback(
        () =>
            setSearchParams(
                current => {
                    current.set('showAll', 'true');
                    return current;
                },
                { replace: true }
            ),
        [setSearchParams]
    );
    useShowAll(onShowAll);

    return null;
};

export const useShowAll = (onShowAll: () => void) => {
    const { ref } = useContext(ShowAllContext);

    useEffect(() => {
        const element = ref?.current;

        element?.addEventListener('click', onShowAll);
        return () => {
            element?.removeEventListener('click', onShowAll);
        };
    }, [ref, onShowAll]);
};
